module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"verificationCode":"Bekreftelseskode (6 siffer)"},"en":{"verificationCode":"Verification code (6 digits)"}}')
  delete Component.options._Ctor
}
